import React, { Fragment } from 'react';
import { 
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  ImageField,
  ShowProps,
  NumberField,
  BooleanInput,
  ReferenceInput,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  SelectInput,
  TextInput,
  ReferenceField,
  ArrayField,
  Datagrid,
  RichTextField


} from 'react-admin'
import { makeStyles } from '@material-ui/styles';
import Description from './Description';
import Nutrition from './Nutrition';
// import RichTextField from "ra-input-rich-text";

const useStyles = makeStyles((table) => ({
  description: {
    width:800,
    padding:1,
  },
  nutrition: {
    width:600
  }
}))

export const ProductShow = (props: ShowProps) => (
    <Show {...props}>
<SimpleShowLayout>
            <TextField source="id" label="ID" />
            <TextField source="name_en" label="Name (English)" />
            <TextField source="name_ar" label="Name (Arabic)" />
            <ReferenceField source="category_id" reference="categories"><TextField source="id" label="Category ID"/></ReferenceField>
            <TextField source="featured_image" label="Featured Image" />
            <TextField source="images" label="Images" />
            <RichTextField source="short_desc_en" label="Short Description (English)"/>
            <RichTextField source="short_desc_ar" label="Short Description (Arabic)"/>
            <TextField source="long_desc_en" label="Long Description (English)"/>
            <TextField source="long_desc_ar" label="Long Description (Arabic)"/>
            <ArrayField source="nutrition" label="Nutrition Information">
              <Datagrid>
                <TextField source="label" label="Label" />
                <TextField source="style" label="Style" />
                <NumberField source="value" label="Value" />
                <TextField source="label_ar" label="Label (Arabic)" />
                <TextField source="label_en" label="Label (English)" />
                <NumberField source="value_ar" label="Value (Arabic)" />
                <NumberField source="value_en" label="Value (English)" />
              </Datagrid>
            </ArrayField>
            <NumberField source="price" label="Price" />
            <NumberField source="active" label="Active" />
            <DateField source="created_at" label="Created At" />
            <DateField source="updated_at" label="Updated At" />
        </SimpleShowLayout>

    </Show>
);

export default ProductShow;